// extracted by mini-css-extract-plugin
export default {"field":"Input_field__qBW4d","label":"Input_label__3B4Ld","input":"Input_input__ec2ym","error":"Input_error__OoT-6","errorText":"Input_errorText__pgRLl"};